// extracted by mini-css-extract-plugin
export default {"inputPanel":"TaskGroupsForm_inputPanel__YxRuz","label":"TaskGroupsForm_label__0+LWU"};